import React, { useState, useContext } from "react";
import Footer from "./Footer";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import Header from "./Header";
import { CartContext } from "./CartContext";
import { FaStar, FaShoppingCart, FaSearch } from "react-icons/fa";

function Shop() {
  const { addToCart } = useContext(CartContext);
  const [priceRange, setPriceRange] = useState([0, 100]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [sortBy, setSortBy] = useState("default");
  const [searchTerm, setSearchTerm] = useState("");

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Get unique categories from product data
  const categories = [
    "All",
    ...new Set(productData.map((item) => item.category)),
  ];

  // Filter products based on price, category, and search
  const filteredProducts = productData.filter((product) => {
    const price = parseFloat(product.price);
    const matchesPrice = price >= priceRange[0] && price <= priceRange[1];
    const matchesCategory =
      selectedCategory === "All" || product.category === selectedCategory;
    const matchesSearch = product.name
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    return matchesPrice && matchesCategory && matchesSearch;
  });

  // Sort products
  const sortedProducts = [...filteredProducts].sort((a, b) => {
    switch (sortBy) {
      case "price-low":
        return parseFloat(a.price) - parseFloat(b.price);
      case "price-high":
        return parseFloat(b.price) - parseFloat(a.price);
      case "rating":
        return parseFloat(b.rating) - parseFloat(a.rating);
      case "reviews":
        return parseInt(b.reviews) - parseInt(a.reviews);
      default:
        return a.id - b.id;
    }
  });

  // Handle add to cart
  const handleAddToCart = (product) => {
    addToCart(product);
    alert(`${product.name} added to cart!`);
  };

  // Render star rating
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`full-${i}`} className="star-icon filled" />);
    }

    if (hasHalfStar) {
      stars.push(<FaStar key="half" className="star-icon half" />);
    }

    const emptyStars = 5 - stars.length;
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<FaStar key={`empty-${i}`} className="star-icon empty" />);
    }

    return stars;
  };

  return (
    <div className="shop main">
      <Header />

      {/* Main Content */}
      <div className="shop-content">
        {/* Hero Section */}
        <div className="shop-hero">
          <div className="hero-content">
            <h1 className="hero-title">EVERYDAY PET ESSENTIALS</h1>
            <p className="hero-subtitle">
              Thoughtfully selected for life with pets
            </p>
          </div>
        </div>

        {/* Shop Container */}
        <div className="shop-container">
          {/* Filter Section */}
          <div className="filter-section">
            {/* Search Bar */}
            <div className="search-filter">
              <div className="search-input-wrapper">
                <FaSearch className="search-icon" />
                <input
                  type="text"
                  placeholder="Search products..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            {/* Sort Options */}
            <div className="sort-section">
              <label>Sort by:</label>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
              >
                <option value="default">Featured</option>
                <option value="price-low">Price: Low to High</option>
                <option value="price-high">Price: High to Low</option>
                <option value="rating">Highest Rated</option>
                <option value="reviews">Most Reviews</option>
              </select>
            </div>

            {/* Category Filter */}
            <div className="category-filter">
              <h3>Category</h3>
              <div className="category-list">
                {categories.map((category) => (
                  <button
                    key={category}
                    className={`category-btn ${
                      selectedCategory === category ? "active" : ""
                    }`}
                    onClick={() => setSelectedCategory(category)}
                  >
                    {category}
                  </button>
                ))}
              </div>
            </div>

            {/* Results Count */}
            <div className="results-count">
              <p>
                Showing {sortedProducts.length} of {productData.length} products
              </p>
            </div>
          </div>

          {/* Products Grid */}
          <div className="products-section">
            <div className="products-grid">
              {sortedProducts.length > 0 ? (
                sortedProducts.map((product) => (
                  <div key={product.id} className="product-card">
                    <Link
                      to={`/shopDetails/${product.id}`}
                      className="product-link"
                      onClick={toTop}
                    >
                      <div className="product-image-wrapper">
                        <img
                          src={product.image}
                          alt={product.name}
                          className="product-image"
                        />
                      </div>
                    </Link>

                    <div className="product-info">
                      <div className="product-rating">
                        <span className="stars">
                          {renderStars(product.rating)}
                        </span>
                        <span className="rating-text">({product.reviews})</span>
                      </div>

                      <Link
                        to={`/shopDetails/${product.id}`}
                        className="product-link"
                        onClick={toTop}
                      >
                        <h3 className="product-name">{product.name}</h3>
                      </Link>

                      <div className="product-price-row">
                        <span className="product-price">${product.price}</span>
                        <span className="product-reviews">
                          {product.reviews} reviews
                        </span>
                      </div>

                      <button
                        className="add-to-cart-btn"
                        onClick={() => handleAddToCart(product)}
                      >
                        <FaShoppingCart className="cart-icon" />
                        Add to Cart
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-products">
                  <p>No products found matching your criteria.</p>
                  <button
                    onClick={() => {
                      setSelectedCategory("All");
                      setPriceRange([0, 100]);
                      setSearchTerm("");
                    }}
                  >
                    Clear Filters
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Shop;
